/**
 * @description Hook utilizado para manipular os veículos do sistema
 * @author Diego Sabino Amorim de Araújo
 * @file useVeiculoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useVeiculoService = () => {
  const fetch = useFetch()

  const listarVeiculoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/veiculo/${id}`)
      return response.data.veiculo
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarVeiculos = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/veiculo`)
      return response.data.veiculos
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarVeiculo = async (id, setVeiculo, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/veiculo/${id}`)
      setVeiculo(response.data.veiculo)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarVeiculoDetalhadoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/veiculo/detalhado/${id}`)
      return response.data.veiculo
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarVeiculosDeCasoAsync = async (idCaso, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/veiculo/deCaso/${idCaso}`)
      return response.data.veiculos
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarVeiculo = async (idCaso, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosVeiculo = {
        ...dados,
        idCaso,
      }
      const result = await fetch.postOpen('/veiculo', dadosVeiculo)
      return result.data.veiculo
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const importarVeiculosNoCaso = async (idCaso, veiculosImportar, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.postOpenWithoutFeedback(`/veiculo/importarVeiculosNoCaso/${idCaso}`, veiculosImportar)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const editarVeiculo = async (id, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.putOpen(`/veiculo/${id}`, dados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarCasosDeVeiculo = async (idVeiculo, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/veiculo/listarCasosDeVeiculo/${idVeiculo}`)
      return response.data.casos
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }


  return {
    listarVeiculo,
    listarVeiculoAsync,
    cadastrarVeiculo,
    listarVeiculosDeCasoAsync,
    listarVeiculoDetalhadoAsync,
    editarVeiculo,
    listarVeiculos,
    importarVeiculosNoCaso,
    listarCasosDeVeiculo,
  }
}
